<script lang="ts">
  import { soldInUnits, soldInCases, isKeg } from "@shared/svelte/ProductHelpers.js";
  import moneyFilters from "@shared/filters/money.js";
  import ListPrice from "@retailer/svelte/ProductDetails/Components/ListPrice.svelte";
  import Price from "@retailer/svelte/Shared/Price.svelte";
  import type { Product, ProductLine } from "@shared/types/ProductLine";
  import { InventoryItemStore } from "@retailer/svelte/CartWidget/v2/Stores/InventoryItemStore";
  export let customPricingMode: boolean;
  export let deleteCustomPrice: any;
  export let priceEditCase: { [key: number]: number } = {};
  export let priceEditUnit: { [key: number]: number } = {};
  export let priceSubmitPending: boolean;
  export let product: Product;
  export let productLine: ProductLine;
  export let showListPrice: boolean;

  $: inventoryItemSoldBy = $InventoryItemStore?.inventoryItems[product.inventory_id]?.sold_by;
  $: product_unit_price = product.unit_price;
  $: product_case_price = product.case_price;
</script>

<div>
  {#if !customPricingMode}
    <div class="fizz-flex-row-4 fizz-align-content-start">
      {#if product_case_price || product_unit_price}
        {#if product.has_custom_price && !product.has_integrated_price}
          <div>Custom Price:</div>
        {/if}
        <div class="fizz-text-medium fizz-text-strong">
          <Price {product} {productLine} />
        </div>
      {/if}
    </div>
    {#if showListPrice && (product_case_price || product_unit_price)}
      <ListPrice {product} {productLine} />
    {/if}
  {:else}
    <div class="media-fixed align-right">
      {#if soldInUnits(product, productLine, inventoryItemSoldBy)}
        <div
          class="custom-price-input unit-price input-wrapper quantity-input vertical-align-middle"
        >
          <input
            type="number"
            class="input"
            placeholder={moneyFilters.filter2()(product_unit_price)}
            data-testid="priceEditUnit-{product.id}"
            bind:value={priceEditUnit[product.id]}
          />
          <span class="input__label">per {product.container_type}</span>
        </div>
      {/if}
      {#if soldInCases(product, productLine, inventoryItemSoldBy)}
        <div
          class="custom-price-input case-price input-wrapper quantity-input vertical-align-middle"
        >
          <input
            type="number"
            class="input"
            placeholder={moneyFilters.filter2()(product_case_price)}
            data-testid="priceEditCase-{product.id}"
            bind:value={priceEditCase[product.id]}
          />
          <span class="input__label">per case</span>
        </div>
      {/if}
      {#if isKeg(product)}
        <div
          class="custom-price-input unit-price input-wrapper quantity-input vertical-align-middle"
        >
          <input
            type="number"
            class="input"
            placeholder={moneyFilters.filter2()(product_unit_price)}
            bind:value={priceEditUnit[product.id]}
          />
          <span class="input__label">per keg</span>
        </div>
      {/if}
      {#if product.has_custom_price}
        <button
          class="button button--label button--alert margin-top--smallest"
          disabled={priceSubmitPending}
          on:click={deleteCustomPrice(product)}
        >
          Delete
        </button>
      {/if}
    </div>
  {/if}
</div>
